import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const ClientEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Client Information</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="name" fullWidth />
        <TextInput source="registrationNumber" label="Registration Number" fullWidth />
        <TextInput source="taxNumber" label="Tax Number" fullWidth />
        <SelectInput
          source="status"
          choices={['Draft', 'Active', 'Inactive'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
    </SimpleForm>
  </Edit>
);
